import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "@/shared/ui/input";
import { Button } from "@/shared/ui/button";
import { PlusIcon } from "lucide-react";
import { TagsTable } from "@/features/tags/pages/TagsTable";
import { useCustomQuery } from "@/shared/hooks/useCustomQuery";
import TagsService from "@/features/tags/service/tagService";
import { useDebounce } from "@/shared/hooks/useDebounce";
import { PageContent } from "@/shared/widgets/layout/PageContent";
import { usePagination } from "@/features/analytics/hooks/usePagination";

export default function TagsPage() {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const { currentPage, setCurrentPage, limit, setLimit, totalPages, setTotalPages } = usePagination()
    const debouncedSearchQuery = useDebounce(searchQuery, 500);

    const { data: paginatedTags, isLoading } = useCustomQuery({
        serviceInstance: TagsService.Instance,
        selectAction: (s) => s.getTags,
        parameter: { page: currentPage, limit },
    });

    const handleCreateNew = () => {
        navigate('/tags/new');
    };

    const createButton = (
        <Button onClick={handleCreateNew}>
            <PlusIcon className="h-4 w-4 mr-2" />
            Nova Tag
        </Button>
    );

    return (
        <PageContent
            title="Tags"
            actions={createButton}
        >
            <div className="mb-8 w-full">
                <Input
                    type="text"
                    placeholder="Pesquise por nome da tag"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="bg-[#222222] border-[#333333] text-white placeholder:text-gray-400 w-full"
                />
            </div>

            <div className="rounded-lg overflow-hidden w-full">
                <TagsTable
                    tags={paginatedTags?.data || []}
                    isLoading={isLoading}
                    onEdit={(tag) => navigate(`/tags/edit/${tag.id}`, { state: { tag } })}
                />
            </div>
        </PageContent>
    );
}